import { z } from 'zod';

export const developmentSiteTemplateSchema = z.enum(['dev', 'harmony']);

export type DevelopmentSiteTemplate = z.infer<
  typeof developmentSiteTemplateSchema
>;
